module.exports = __webpack_public_path__ + "img/auth_banner_dx.ddb6b09a.jpg";